module.exports = __webpack_public_path__ + "h5/img/support.3b10ced7.png";